import { Component } from '@angular/core';

@Component({
    selector: 'app-default-right-sidebar',
    templateUrl: './default-right-sidebar.component.html',
    styleUrls: ['./default-right-sidebar.component.scss'],
    standalone: false
})
export class DefaultRightSidebarComponent {

}
